import { render, staticRenderFns } from "./nissinView.vue?vue&type=template&id=297e1c8a&scoped=true"
import script from "./nissinView.vue?vue&type=script&lang=js"
export * from "./nissinView.vue?vue&type=script&lang=js"
import style0 from "./nissinView.vue?vue&type=style&index=0&id=297e1c8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297e1c8a",
  null
  
)

export default component.exports